import React from "react";
import { Link } from "react-router-dom";
import { BsFillArrowRightCircleFill } from "react-icons/bs";

const RecentRegisterJobs = ({ dashboardData }) => {
  const searches = [
    { id: 1, name: "John Doe", keyword: "React Developer", exp: "3 Years", location: "New York" },
    { id: 2, name: "Jane Smith", keyword: "Project Manager", exp: "5 Years", location: "Los Angeles" },
    { id: 3, name: "Alice Johnson", keyword: "UI/UX Designer", exp: "2 Years", location: "Chicago" },
    // Add more saved searches as needed
  ];

  console.log(dashboardData?.latest?.candidates);


  return (
    <>
      <div className="recentCard">
        <div className="portTitle">
          <h5>Recently Candidates</h5>
        </div>
        <div className="feeds">
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Sr. No</th>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Mobile</th>
                <th scope="col">Exp</th>
                <th scope="col">Location</th>
              </tr>
            </thead>
            <tbody>
              {dashboardData?.latest?.candidates?.map((item, index) => (
                <tr key={item._id}>
                  <td>{index + 1}</td>
                  <td>{item?.firstname} {item?.lastname}</td>
                  <td>{item?.email}</td>
                  <td>{item?.mobile}</td>
                  <td>{item?.exprience}</td>
                  <td>{item?.location?.city}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="seeAll">
          <Link to="#">
            See All Saved Searches <BsFillArrowRightCircleFill />{" "}
          </Link>
        </div>
      </div>
    </>
  );
};

export default RecentRegisterJobs;
